import { toast } from "sonner";
import { ArrowRight, Flame } from "lucide-react";
import { GlassCard } from "@/components/erp";
import { isiRenk } from "@/components/depo/Depo3D";
import api, { errMsg } from "@/lib/api";

export const isiGozler = (isi) => Object.fromEntries(Object.entries(isi?.sayim || {}).map(([k, n]) => {
  const t = isi.max ? n / isi.max : 0;
  return [k, { doluluk: Math.max(20, t * 100), renkOzel: isiRenk(t), icerik: [], hareket: n }];
}));

export const IsiLejant = ({ max }) => (
  <div className="flex items-center gap-2 text-[11px]" data-testid="isi-lejant"><span>Az</span><span className="w-28 h-2.5 rounded-full" style={{ background: `linear-gradient(90deg, ${isiRenk(0)}, ${isiRenk(0.5)}, ${isiRenk(1)})` }} /><span>Çok ({max} hareket)</span></div>
);

export const TasimaOnerileri = ({ isi, depo, yaz, onDone }) => {
  const tasi = async (o) => {
    try { await api.post("/stok/transfer", { bakiye_id: o.bakiye_id, hedef_depo_id: depo, hedef_konum: o.hedef, miktar: o.miktar, aciklama: "Isı haritası önerisiyle taşıma" }); toast.success(`${o.kod}: ${o.kaynak} → ${o.hedef}`); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <GlassCard className="p-3" data-testid="isi-oneriler"><div className="text-sm font-semibold mb-1 flex items-center gap-1.5"><Flame className="w-4 h-4 text-orange-400" />Taşıma önerileri</div>
      <p className="text-[10px] text-muted-foreground mb-2">Son {isi.gun} günde sık çıkan ürünler girişten uzaksa, girişe yakın boş göze taşımak yolu kısaltır.</p>
      {isi.oneriler.length === 0 ? <div className="text-xs text-emerald-300">Öneri yok, yerleşim verimli</div> : isi.oneriler.map((o, i) => (
        <div key={o.bakiye_id} className="text-[11px] py-1.5 border-t border-white/5" data-testid={`isi-oneri-${i}`}>
          <div className="flex justify-between gap-2"><span className="truncate"><span className="font-mono">{o.kod}</span> · {o.cikis_sayisi} çıkış</span><span className="text-emerald-300 shrink-0">-{o.toplam_m} m</span></div>
          <div className="flex items-center gap-1 font-mono text-[var(--g1)]">{o.kaynak}<ArrowRight className="w-3 h-3" />{o.hedef}<span className="text-muted-foreground font-sans ml-1">({o.tur_basi_m} m/tur · {o.miktar} {o.birim})</span>
            {yaz && <button data-testid={`isi-tasi-${i}`} onClick={() => tasi(o)} className="ml-auto px-2 h-6 rounded-md border border-[var(--g1)] text-[var(--g1)] font-sans">Taşı</button>}</div>
        </div>))}
    </GlassCard>
  );
};
